// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchInput_searchWrapper__a+ueI","search":"SearchInput_search__VPD+z"};